import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import { FavoritesProvider } from "@/context/FavoritesContext";
import { ThemeProvider } from "@/context/ThemeContext";
import { LanguageProvider } from "@/context/LanguageContext";
import { AuthProvider } from "@/context/AuthContext";
import Home from "@/pages/Home";
import Region from "@/pages/Region";
import Quiz from "@/pages/Quiz";
import Chat from "@/pages/Chat";
import About from "@/pages/About";
import Favorites from "@/pages/Favorites";
import Diagnose from "@/pages/Diagnose";
import Cases from "@/pages/Cases";
import Flashcards from "@/pages/Flashcards";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import AuthCallback from "@/pages/AuthCallback";
import Forum from "@/pages/Forum";
import ForumThread from "@/pages/ForumThread";
import Profile from "@/pages/Profile";
import VerifyEmail from "@/pages/VerifyEmail";

function App() {
  return (
    <div className="App grain-bg" data-testid="app-root">
      <ThemeProvider>
        <LanguageProvider>
          <AuthProvider>
            <FavoritesProvider>
              <BrowserRouter>
                <Layout>
                  <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/regioner/:regionId" element={<Region />} />
                    <Route path="/quiz" element={<Quiz />} />
                    <Route path="/flashcards" element={<Flashcards />} />
                    <Route path="/fall" element={<Cases />} />
                    <Route path="/assistent" element={<Chat />} />
                    <Route path="/favoriter" element={<Favorites />} />
                    <Route path="/differentialdiagnos" element={<Diagnose />} />
                    <Route path="/om" element={<About />} />
                    <Route path="/forum" element={<Forum />} />
                    <Route path="/forum/:threadId" element={<ForumThread />} />
                    <Route path="/logga-in" element={<Login />} />
                    <Route path="/registrera" element={<Register />} />
                    <Route path="/auth/callback" element={<AuthCallback />} />
                    <Route path="/auth/verifiera" element={<VerifyEmail />} />
                    <Route path="/profil" element={<Profile />} />
                  </Routes>
                </Layout>
              </BrowserRouter>
            </FavoritesProvider>
          </AuthProvider>
        </LanguageProvider>
      </ThemeProvider>
      <Toaster position="top-right" richColors closeButton theme="system" />
    </div>
  );
}

export default App;
